import React from 'react'

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
       An open, crowd-sourced database of drinks and cocktails from around the world.
       Cocktail is "An alcoholic drink consisting of a spirit or spirits mixed with other ingredients, such as fruit juice or cream"
      </p>
    </section>
  );
}

export default About
